export enum DeprecatedDatePickerDataHooks {
  DATE_PICKER = 'deprecated-date-picker',
  DOT_ICON = 'deprecated-dot-icon',
}
